<style lang="stylus" scoped>
.sx-container
  position fixed
  left 0
  right 0
  top 0
  bottom 0
  z-index 9999
  background rgba(255, 255, 255, 0.65)
  .load-text
    margin-top 15px
    color #1890ff
</style>

<template>
  <div class="sx-container sx-layout-center" v-if="loading">
    <div class="sx-align-center">
      <a-spin />
      <p class="load-text">{{ loadingText }}</p>
    </div>
  </div>
</template>
<script>
const text = '拼命加载中...';

export default {
  name: 'GlobalLoad',

  data() {
    return {};
  },

  computed: {
    loading() {
      return this.$store.state.globalLoad.loading;
    },

    loadingText() {
      return this.$store.state.globalLoad.text || text;
    }
  }
};
</script>
